import styled from 'styled-components'

export const Canvas = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 60px);
  overflow: hidden;

  .rbc-overflowing {
    margin-right: -1px !important;
  }

  @media (max-width: 1024px) {
    max-height: calc(100vh - 50px);
    overflow: hidden;
  }
`

export const Loading = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: center;
  width: 100%;
  height: 100%;
`
